import React from 'react'

function HighLight(props) {
    const highLights = props.content;

    const handleClick = (elementId) => {
        const scrolledDiv = document.getElementById(elementId);
        const offset = scrolledDiv.offsetTop - 100;

        window.scrollTo({
            top: offset,
            behavior: "smooth",
        });
    }

    return (
        <ul>
            {
                (highLights) ? (
                    highLights.map(function (elements, index) {
                        const remove_html_regex = /(<([^>]+)>)/ig;
                        const result = elements.replace(remove_html_regex, '');
                        return (
                            <li onClick={() => handleClick(`highlight_${index}`)} key={`highlights_${index}`}>
                                <a>{result}</a>
                            </li>
                        )
                    })
                ) : null

            }
        </ul>
    );
}
export default HighLight;